import axios from 'axios';
import Router from '../router'; 

//axios.defaults.baseURL = 'http://localhost:8080/api'; // Local host
//axios.defaults.baseURL = 'https://test.dofbasen.dk/DanmarksFugleBackend/api'; // Test server
axios.defaults.baseURL = 'https://service.dofbasen.dk/DanmarksFugleBackend/api'; // Live server

axios.defaults.headers = {
    "Content-Type": "application/json",
    'Accept': 'application/json',
}

function getLocalAccessToken() {
    const accessToken = JSON.parse(window.localStorage.getItem("access_token"))
    return accessToken
}
function getLocalRefreshToken() {
    const refreshToken = JSON.parse(window.localStorage.getItem("refresh_token"))
    return refreshToken
}

function refreshToken() {
    return axios.get("/token/refresh")
}

axios.interceptors.request.use(
    (config) => {
        //console.log("config.url is: "+config.url)
        const token = config.url == '/token/refresh' ? getLocalRefreshToken() : getLocalAccessToken()
        //console.log("using token for request: "+token)
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
)

axios.interceptors.response.use(
    (response) => {
        /* 
        Any status code from range of 2xx
        Do something with response data
        */
       return response
    },
    async (error) => {
        const originalConfig = error.config
        /*
        Any status codes outside range of 2xx
        Do something with response error
        */
       if (error.response) {
           if (error.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true
                try {
                    const rs = await refreshToken()
                    window.localStorage.setItem("access_token", JSON.stringify(rs.data.access_token))
                    //const token = getLocalAccessToken()
                    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + rs.data.access_token
                    // the above part was in tutorial, but caused error, while things seems to work without it
                    return axios(originalConfig)
                } catch (_error) {
                    if (_error.response && _error.response.data && _error.response.status) {
                        // in case of 403 status remove access and refresh token and redirect user to login page
                        if (_error.response.status === 403) {
                            window.localStorage.removeItem("access_token")
                            window.localStorage.removeItem("refresh_token")
                            Router.push({name:"Login"})
                        }
                        return Promise.reject(_error.response.data)
                    }
                    return Promise.reject(_error)
                }
                
           }
           if (error.response.status === 403) {
                console.log("403 error")
                //Nedenstående er udkommenteret da vi skal blive på rediger tekst/facts ved fejl
                //Router.push({name:"Login"})
                return Promise.reject(error)
           }
       }
       return Promise.reject(error)
    }
)